import { useState } from "react"
import { TabSection } from "pages/Purchase/Transaction/components"
import { Journal } from "../../PurchaseOrder/components/Tab/components"
import { useTabList } from "../hooks"
import { PaymentBillService } from "../../EnterBill/components/displays/PaymentBillService"

export const TabBillService = () => { 
  const content = [PaymentBillService, Journal]
  const [currentTab, setCurrentTab] = useState<number>(0)

  return (
    <section>
      <TabSection
        activeIndex={currentTab}
        list={useTabList}
        onChangeTab={setCurrentTab}
      />

      {content.map((Element, key) => {
        if (currentTab === key) {
          return <Element key={key} />
        }

        return null
      })}
    </section>
  )
}